<template>
  <canvas id="myChart" />
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  name: 'LineChart',
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    chart: null,
  }),
  watch: {
    chartData: {
      handler(newChartData) {
        this.chart.data = newChartData;
        this.chart.update();
      },
      deep: true,
    },
  },
  mounted() {
    const ctx = this.$el;
    this.chart = new Chart(ctx, {
      type: 'line',
      data: this.chartData,
      options: this.options,
    });
  },
};
</script>
